module.exports = __webpack_public_path__ + "img/madison-daniel.fed3c77f.jpg";